import {getEventHistoryList} from '../api/getEventHistoryList';
import {setGetEventHistoryListAction} from '../action';

const setGetEventHistoryList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getEventHistoryList(params);
    
            if (data.status === 'success') {
                dispatch(setGetEventHistoryListAction({
                    list: data.data.list,
                    count: data.data.count
                }));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetEventHistoryList
}